import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as action from '../actions/inputOperation';
import { post } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* getOperation({ payload }) {
  try {
    const request = yield call(
      post,
      `/operation/material/${
        payload.operationType === 5 ? 'getAllWaste' : 'get'
      }`,
      payload
    );
    yield put(action.getOperationSuccess(request));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getOperationFail());
  }
}

export function* saveOperation({ payload }) {
  try {
    const request = yield call(
      post,
      `/operation/material/${
        payload.operationType === 5 ? 'saveallwaste' : 'save'
      }`,
      payload
    );
    yield put(action.saveOperationSuccess(request));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.saveOperationFail());
  }
}
